import React, { FC } from 'react';
import { Instance } from '@popperjs/core';
import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

import { EllipsisTooltipTextProps } from './types';

const EllipsisTooltipText: FC<EllipsisTooltipTextProps> = ({
  text,
  className
}) => {
  const positionRef = React.useRef({
    x: 0,
    y: 0
  });
  const popperRef = React.useRef<Instance | null>(null);
  const areaRef = React.useRef<HTMLDivElement>(null);

  const BootstrapTooltip = styled(
    ({ className: classNames, ...props }: TooltipProps) => (
      <Tooltip {...props} arrow classes={{ popper: classNames }} />
    )
  )(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black
    }
  }));

  const handleMouseMove = (event: React.MouseEvent<HTMLDivElement>) => {
    positionRef.current = { x: event.clientX, y: event.clientY };

    if (popperRef.current != null) {
      popperRef.current.update();
    }
  };

  return (
    <BootstrapTooltip
      title={text}
      placement="top"
      slotProps={{
        popper: {
          popperRef,
          anchorEl: {
            getBoundingClientRect: () => {
              return new DOMRect(
                positionRef.current.x,
                areaRef?.current?.getBoundingClientRect().y,
                0,
                0
              );
            }
          }
        }
      }}>
      <div
        ref={areaRef}
        onMouseMove={handleMouseMove}
        className={className}
        style={{ whiteSpace: 'nowrap' }}>
        {text}
      </div>
    </BootstrapTooltip>
  );
};

export default EllipsisTooltipText;
